import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/become-a-partner/components/BecomeAPartnerSection2.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/BackgroundVideo.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/common/components/FAQCollapse.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionWrapper.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/common/components/SectionFAQ.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/become-a-partner/components/BecomeAPartnerSection1.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/app/[locale]/become-a-partner/page.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/image-component.js");
